export default {"src":"/_next/static/media/warranty.17e48f3d.svg","height":21,"width":21};